// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__vT6wV","title":"AfterFrontImage_title__14rnD"};